import { clsx } from '@alexis/helpers/clsx';
import CheckboxItem from '@pages/FlightSearchResult/components/CheckboxItem';
import { useFlightPLS } from '@pages/FlightSearchResult/contexts/FlightPerLegSearchContext/FlightPerLegSearchContext';
import useFlightSearchFilters from '@pages/FlightSearchResult/hooks/useFlightSearchFilters';
import useFlightSearchPageParams from '@pages/FlightSearchResult/hooks/useFlightSearchPageParams';
import { useSelector } from 'react-redux';

import { convertFilterStateToDataForTracking } from '@helpers/flight';

import useFlightSearchResultsDatadog from '@hooks/useFlightSearchResultsDatadog';

import { getTranslationsState } from '@redux/selectors';

import { FlightSearchResultSearchParams } from '@wegoTypes/flights/flightSearchParams';

import styles from '../FlightFilterCategoryContent.module.scss';

const FLIGHT_EXPERIENCES = [
  {
    text: 'no_overnight',
    value: 'no_overnight_flight',
  },
  {
    text: 'short_stop_overs',
    value: 'no_long_stopover',
  },
];

type FlightExperiencesFilterProps = {
  className?: string;
  genzoTrackApplyFilterSearchView: () => void;
  genzoTrackApplyFilterActionEvent: any;
};

const FlightExperiencesFilter: React.FC<FlightExperiencesFilterProps> = ({
  className,
  genzoTrackApplyFilterSearchView,
  genzoTrackApplyFilterActionEvent,
}) => {
  const { activeLeg } = useFlightSearchFilters();
  const { isPerLegSearch } = useFlightPLS();

  const translations = useSelector(getTranslationsState);

  const { flightExperiencesFilter, toggleMultiCitySingleFilter } = useFlightSearchFilters();

  const { isMultiCity } = useFlightSearchPageParams();

  const { recordChangeFilterAction } = useFlightSearchResultsDatadog();

  const selectedFlightExperiencesForActiveLeg =
    flightExperiencesFilter.find((item) => item.leg === activeLeg)?.values || [];

  const handleFlightExperienceChanged = (experience: string) => {
    recordChangeFilterAction();

    const newFitler = toggleMultiCitySingleFilter({
      searchParamKey: FlightSearchResultSearchParams.Experience,
      value: experience,
      activeLeg,
    });

    genzoTrackApplyFilterActionEvent('filter', 'applied', {
      itinerary: convertFilterStateToDataForTracking(
        newFitler,
        isMultiCity,
        true,
        isPerLegSearch,
        activeLeg,
      ),
    });
    genzoTrackApplyFilterSearchView();
  };

  return (
    <div className={clsx(styles.categoryContent, className && styles.inDropdown)}>
      {FLIGHT_EXPERIENCES.map((experience) => (
        <CheckboxItem
          className={className}
          key={experience.value}
          isChecked={selectedFlightExperiencesForActiveLeg.includes(experience.value)}
          label={translations[experience.text] as string}
          onCheckboxToggle={() => handleFlightExperienceChanged(experience.value)}
        />
      ))}
    </div>
  );
};

export default FlightExperiencesFilter;
